import {
    BUSINESSNATURESUBCATEGORYTYPE_SUCCESS,
    BUSINESSNATURESUBCATEGORYTYPE_FAILED,
    RESET_BUSINESSNATURESUBCATEGORYTYPE,
    LOADING_BUSINESSNATURESUBCATEGORYTYPE,
    NETWORK_ERROR_BUSINESSNATURESUBCATEGORYTYPE,
} from "../types/index";

const initialState = {
    isLoading: false,
    success: false,
    network: false,
    failed: false,
    data: {},
};

export default (state = initialState, action) => {
    switch (action.type) {
        case LOADING_BUSINESSNATURESUBCATEGORYTYPE:
            return {
                ...state,
                isLoading: true,
                success: false,
                failed: false,
                network: false,
                data: {},
            };
        case BUSINESSNATURESUBCATEGORYTYPE_FAILED:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: true,
                network: false,
                data: action.payload,
            };
        case BUSINESSNATURESUBCATEGORYTYPE_SUCCESS:
            return {
                ...state,
                isLoading: false,
                success: true,
                failed: false,
                network: false,
                data: action.payload,
            };
        case NETWORK_ERROR_BUSINESSNATURESUBCATEGORYTYPE:
            return {
                ...state,
                isLoading: false,
                success: false,
                failed: false,
                network: true,
                data: {},
            };
        case RESET_BUSINESSNATURESUBCATEGORYTYPE:
            return (state = initialState);
        default:
            return state;
    }
};